/* Durga — smooth scroll reveals.
   Native IntersectionObserver + GPU-transform CSS. No GSAP dependency, no polling,
   no late hard-set. The hidden state is gated on html.durga-anim (set pre-paint in
   layout/theme.liquid) so there is no flash and disabled motion never hides content. */
(function () {
  var docEl = document.documentElement;
  // Motion not armed (reduced-motion / small screen / no IO): nothing was hidden — do nothing.
  if (!docEl.classList.contains('durga-anim')) return;

  // Must match the selector list in durga-brand.css (html.durga-anim ... { opacity:0 }).
  var SEL = [
    '.dgd__card',
    '.dcat__head', '.dcat__tile',
    '.dstacks__head', '.dstacks__card',
    '.durga-steps__head', '.durga-steps__item',
    '.durga-promise__head', '.durga-promise__item',
    '.durga-faq__head', '.durga-faq__item',
    '.dst__body',
    '.dpolicy__body'
  ].join(',');

  function run() {
    var els = document.querySelectorAll(SEL);
    if (!els.length) return;

    var io = new IntersectionObserver(function (entries, obs) {
      for (var i = 0; i < entries.length; i++) {
        var e = entries[i];
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          obs.unobserve(e.target);
        }
      }
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });

    els.forEach(function (el) { io.observe(el); });

    // Safety net: if anything is still hidden after full load (e.g. an observer miss),
    // reveal it so content can never stay blank.
    window.addEventListener('load', function () {
      setTimeout(function () {
        els.forEach(function (el) {
          if (!el.classList.contains('is-in')) el.classList.add('is-in');
        });
      }, 1200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
